/** Koszty z księgi Rewizora (etap 4a): kadry wg działów, flota wg pojazdów, produkcja, mapa kont. */
export const costsPl = {
  nav: 'Koszty',
  title: 'Koszty z księgi',
  subtitle: 'Rewizor: kadry wg działów, flota wg pojazdów, produkcja, mapa działów i mapa kont',
  tabs: { payrollFleet: 'Kadry i flota', production: 'Produkcja', departments: 'Działy', accountMap: 'Mapa kont' },
  range: { last12: 'Ostatnie 12 miesięcy', thisYear: 'Bieżący rok', lastYear: 'Poprzedni rok', label: 'Okres' },
  source: {
    lastImport: 'Import z księgi',
    never: 'brak importu',
    demo: 'dane przykładowe',
    demoHint: 'Część pozycji to dane przykładowe — w księdze brak kosztów tych pozycji.',
    ledger: 'z księgi',
  },
  chips: { payroll: 'Kadry', fleet: 'Pojazdy', months: 'Miesiące' },
  payroll: {
    title: 'Koszty kadr wg działów',
    description: 'Konta 404 i 405 rozksięgowane na zespół 5, wg działów klienta (D10). Przypisanie ośrodków do działów: zakładka „Działy”.',
    total: 'Razem',
    others: 'Pozostałe działy',
    empty: 'Brak kosztów kadr w tym okresie. Uruchom import z księgi (erp:costs).',
    department: 'Dział',
    centres: 'Ośrodki',
    wages: 'Wynagrodzenia (404)',
    benefits: 'Składki i świadczenia (405)',
    share: 'Udział',
    noCentre: 'brak ośrodka w księdze — przypisz ośrodek w mapie działów',
    warehouseShifts: 'dzień i noc razem — księga nie rozdziela zmian',
    nightPart: 'w tym noc (szacunek {pct}%)',
    dayPart: 'w tym dzień (szacunek)',
    unassignedHint: 'ośrodki bez działu — przypisz je w zakładce „Działy”',
    unallocatedHint: 'część 404+405, której księgowość nie rozksięgowała jeszcze na ośrodki',
    reconciled: 'Suma działów = obroty kont 404+405 co do grosza w każdym miesiącu.',
    externalTitle: 'Koszty pracy poza etatem',
    externalHint: 'Usługi obce, nie wynagrodzenia — poza sumą 404+405. Umowy B2B: konto 402-19 (402-17 „Transport B2B” to usługa przewozowa i się nie liczy). Agencja pracy: usługi obce opisane w księdze jako agencja pracy / praca tymczasowa.',
    externalKind: 'Pozycja',
    externalTotal: 'Razem poza etatem',
    external: { AGENCY: 'Agencja pracy', B2B: 'Umowy B2B' },
  },
  departments: {
    WAREHOUSE: 'Magazyn',
    LOGISTICS: 'Logistyka',
    PRODUCTION: 'Produkcja',
    CUSTOMER_SERVICE: 'BOK',
    ACCOUNTING: 'Księgowość',
    HR: 'Kadry',
    MANAGEMENT: 'Zarząd',
    PURCHASING: 'Zakupy',
    MARKETING: 'Marketing',
    SORTING: 'Sortownia',
    QUALITY: 'Dział jakości',
    COMPLAINTS: 'Dział reklamacji',
    SALES: 'Dział handlowy',
    UNASSIGNED: 'Nieprzypisane',
    UNALLOCATED: 'Nierozksięgowane na ośrodki',
  },
  deptMap: {
    title: 'Mapa działów — ośrodki zespołu 5',
    description: 'Każdy ośrodek kosztów z księgi należy do jednego działu. Zmiana od razu przelicza koszty kadr — bez ponownego importu.',
    centre: 'Ośrodek',
    name: 'Nazwa w planie kont',
    payroll: 'Kadry (12 mies.)',
    external: 'Poza etatem (12 mies.)',
    department: 'Dział',
    changed: 'zmienione',
    reset: 'Przywróć domyślny ({department})',
    noName: 'bez nazwy',
    vehicles: 'pojazdy {group} (zbiorczo, bez nazw)',
    saved: 'Zapisano mapę działów',
    filterAll: 'Wszystkie ośrodki',
    filterCost: 'Tylko z kosztem',
    filterUnassigned: 'Tylko nieprzypisane',
    empty: 'Brak ośrodków — uruchom import z księgi (erp:costs).',
    nightTitle: 'Magazyn: dzień i noc',
    nightHint: 'Księga nie rozdziela zmian. Możesz podać szacunkowy udział nocy — ekran kadr pokaże wtedy podział Magazynu jako szacunek.',
    nightLabel: 'Udział nocy (%)',
    nightNone: 'bez podziału',
    save: 'Zapisz',
    clear: 'Usuń podział',
  },
  fleet: {
    title: 'Koszty floty wg pojazdów',
    description: 'Konta 505–509: koszt pojazdu wg rodzaju. Dopasowanie do Floty po numerze rejestracyjnym.',
    vehicle: 'Pojazd',
    group: 'Grupa',
    matched: 'Dopasowane',
    unmatched: 'Niedopasowane',
    unmatchedHint: 'Pojazd z księgi bez odpowiednika we Flocie',
    noPlate: 'bez numeru ({centre})',
    total: 'Razem',
    empty: 'Brak kosztów pojazdów w tym okresie.',
    showAll: 'Pokaż wszystkie ({count})',
    showLess: 'Pokaż mniej',
    otherKinds: 'Pozostałe',
  },
  groups: { '505': 'Transport', '506': 'Handlowcy', '507': 'Zakupy', '508': 'Zarząd', '509': 'Motocykle' },
  kinds: {
    FUEL: 'Paliwo',
    RENT_LEASE: 'Najem i leasing',
    DEPRECIATION: 'Amortyzacja',
    REPAIRS: 'Naprawy i serwis',
    WASH_TOLLS: 'Myjnie i autostrady',
    INSURANCE: 'Ubezpieczenia',
    OTHER: 'Inne',
  },
  production: {
    title: 'Produkcja',
    description: 'PW i RW kategorii produkcji (Subiekt) oraz konta 500 i 580 (Rewizor). Sprzedaż wyrobów wg faktur.',
    finishedGoods: 'Wartość wyrobów (PW)',
    materials: 'Materiały (RW)',
    valueAdded: 'Wartość dodana (PW − RW)',
    producedSales: 'Sprzedaż wyrobów (netto)',
    materialsShare: 'Materiały / wyroby',
    ledgerMaterials: 'Konto 500',
    ledgerPlanned: 'Konto 580',
    ledgerNone: 'nie zaksięgowano',
    month: 'Miesiąc',
    docs: 'Dokumenty PW / RW',
    chart: 'Wyroby i materiały w miesiącach',
    products: 'Wyroby — produkcja, sprzedaż i rotacja',
    productsHint: 'Rotacja = sprzedana ilość / wyprodukowana ilość w okresie.',
    excluded: 'Pominięto {count} towarów handlowych tylko okazjonalnie przyjmowanych PW (sprzedaż ponad 3 × produkcja): produkcja {produced}, sprzedaż {sold}.',
    product: 'Wyrób',
    producedQty: 'Wyprodukowano (ilość)',
    producedValue: 'Wartość produkcji',
    soldQty: 'Sprzedano (ilość)',
    soldNet: 'Sprzedaż netto',
    rotation: 'Rotacja',
    empty: 'Brak dokumentów produkcji w tym okresie.',
  },
  map: {
    title: 'Mapa kont Rewizora',
    description: 'Konta zespołu 4 przypisane do kategorii kosztów raportu zarządu.',
    status: { APPROVED: 'Zatwierdzona', PROPOSED: 'Propozycja', MISSING: 'Brak mapy' },
    decision: 'Decyzja {decision}',
    approvedAt: 'zatwierdzona {date}',
    account: 'Konto',
    name: 'Nazwa konta',
    category: 'Kategoria raportu',
    confidence: 'Pewność',
    skip: 'nie wchodzi do kosztów',
    categories: 'Kategorie — koszt z księgi',
    categoriesHint: 'Suma kosztów raportu z księgi za {months} ost. miesięcy',
    accounts: 'Konta',
    amount: 'Koszt',
    search: 'Szukaj konta lub nazwy',
    empty: 'Brak mapy kont — uruchom erp:rewizor-map --propose.',
    confidenceValue: { HIGH: 'wysoka', MEDIUM: 'średnia', LOW: 'niska', APPROVED: 'poprawiona ręcznie' },
  },
  vehicleCard: {
    tab: 'Koszty z księgi',
    title: 'Koszty z księgi (Rewizor)',
    description: 'Konta 505–509 dopasowane po numerze rejestracyjnym — ostatnie 12 miesięcy.',
    empty: 'Księga nie ma kosztów tego pojazdu w ostatnich 12 miesiącach.',
    month: 'Miesiąc',
  },
  error: 'Nie udało się wczytać danych.',
  retry: 'Spróbuj ponownie',
};

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const costsEn: Shape<typeof costsPl> = {
  nav: 'Costs',
  title: 'Ledger costs',
  subtitle: 'Rewizor: payroll by department, fleet by vehicle, production, department map and account map',
  tabs: { payrollFleet: 'Payroll and fleet', production: 'Production', departments: 'Departments', accountMap: 'Account map' },
  range: { last12: 'Last 12 months', thisYear: 'This year', lastYear: 'Last year', label: 'Period' },
  source: {
    lastImport: 'Ledger import',
    never: 'not imported',
    demo: 'example data',
    demoHint: 'Some rows are example data — the ledger has no costs for them.',
    ledger: 'from the ledger',
  },
  chips: { payroll: 'Payroll', fleet: 'Vehicles', months: 'Months' },
  payroll: {
    title: 'Payroll cost by department',
    description: 'Accounts 404 and 405 posted on class 5, by the client\'s departments (D10). Centre to department mapping: the “Departments” tab.',
    total: 'Total',
    others: 'Other departments',
    empty: 'No payroll costs in this period. Run the ledger import (erp:costs).',
    department: 'Department',
    centres: 'Centres',
    wages: 'Wages (404)',
    benefits: 'Contributions and benefits (405)',
    share: 'Share',
    noCentre: 'no cost centre in the ledger — assign one in the department map',
    warehouseShifts: 'day and night together — the ledger does not split shifts',
    nightPart: 'of which night (estimate {pct}%)',
    dayPart: 'of which day (estimate)',
    unassignedHint: 'centres without a department — assign them on the “Departments” tab',
    unallocatedHint: 'part of 404+405 not yet posted on cost centres by accounting',
    reconciled: 'Departments add up to the 404+405 turnover to the grosz in every month.',
    externalTitle: 'Labour outside payroll',
    externalHint: 'External services, not wages — outside the 404+405 total. B2B contracts: account 402-19 (402-17 “B2B transport” is a carrier service and is left out). Employment agency: external services described in the ledger as agency / temporary work.',
    externalKind: 'Item',
    externalTotal: 'Total outside payroll',
    external: { AGENCY: 'Employment agency', B2B: 'B2B contracts' },
  },
  departments: {
    WAREHOUSE: 'Warehouse',
    LOGISTICS: 'Logistics',
    PRODUCTION: 'Production',
    CUSTOMER_SERVICE: 'Customer service',
    ACCOUNTING: 'Accounting',
    HR: 'HR',
    MANAGEMENT: 'Management',
    PURCHASING: 'Purchasing',
    MARKETING: 'Marketing',
    SORTING: 'Sorting room',
    QUALITY: 'Quality',
    COMPLAINTS: 'Complaints',
    SALES: 'Sales',
    UNASSIGNED: 'Unassigned',
    UNALLOCATED: 'Not allocated to cost centres',
  },
  deptMap: {
    title: 'Department map — class-5 cost centres',
    description: 'Every ledger cost centre belongs to one department. A change regroups the payroll costs at once — no re-import.',
    centre: 'Centre',
    name: 'Name in the chart of accounts',
    payroll: 'Payroll (12 mo.)',
    external: 'Outside payroll (12 mo.)',
    department: 'Department',
    changed: 'changed',
    reset: 'Back to default ({department})',
    noName: 'no name',
    vehicles: 'vehicles {group} (summed up, no names)',
    saved: 'Department map saved',
    filterAll: 'All centres',
    filterCost: 'With cost only',
    filterUnassigned: 'Unassigned only',
    empty: 'No cost centres — run the ledger import (erp:costs).',
    nightTitle: 'Warehouse: day and night',
    nightHint: 'The ledger does not split shifts. You can enter an estimated night share — the payroll view then shows the Warehouse split as an estimate.',
    nightLabel: 'Night share (%)',
    nightNone: 'no split',
    save: 'Save',
    clear: 'Remove split',
  },
  fleet: {
    title: 'Fleet cost by vehicle',
    description: 'Accounts 505–509: vehicle cost by kind. Matched to the Fleet by registration number.',
    vehicle: 'Vehicle',
    group: 'Group',
    matched: 'Matched',
    unmatched: 'Not matched',
    unmatchedHint: 'Ledger vehicle without a Fleet record',
    noPlate: 'no plate ({centre})',
    total: 'Total',
    empty: 'No vehicle costs in this period.',
    showAll: 'Show all ({count})',
    showLess: 'Show less',
    otherKinds: 'Other',
  },
  groups: { '505': 'Transport', '506': 'Sales reps', '507': 'Purchasing', '508': 'Management', '509': 'Motorcycles' },
  kinds: {
    FUEL: 'Fuel',
    RENT_LEASE: 'Rent and leasing',
    DEPRECIATION: 'Depreciation',
    REPAIRS: 'Repairs and service',
    WASH_TOLLS: 'Washing and tolls',
    INSURANCE: 'Insurance',
    OTHER: 'Other',
  },
  production: {
    title: 'Production',
    description: 'Production receipts and issues (Subiekt) and accounts 500 and 580 (Rewizor). Sales of goods by invoice.',
    finishedGoods: 'Finished goods value',
    materials: 'Materials issued',
    valueAdded: 'Value added',
    producedSales: 'Sales of produced goods (net)',
    materialsShare: 'Materials / goods',
    ledgerMaterials: 'Account 500',
    ledgerPlanned: 'Account 580',
    ledgerNone: 'not posted',
    month: 'Month',
    docs: 'Receipts / issues',
    chart: 'Goods and materials by month',
    products: 'Products — production, sales and rotation',
    productsHint: 'Rotation = quantity sold / quantity produced in the period.',
    excluded: 'Left out {count} traded goods only occasionally received by production (sales over 3 × production): production {produced}, sales {sold}.',
    product: 'Product',
    producedQty: 'Produced (qty)',
    producedValue: 'Production value',
    soldQty: 'Sold (qty)',
    soldNet: 'Net sales',
    rotation: 'Rotation',
    empty: 'No production documents in this period.',
  },
  map: {
    title: 'Rewizor account map',
    description: 'Class-4 accounts assigned to the cost categories of the management report.',
    status: { APPROVED: 'Approved', PROPOSED: 'Proposal', MISSING: 'No map' },
    decision: 'Decision {decision}',
    approvedAt: 'approved {date}',
    account: 'Account',
    name: 'Account name',
    category: 'Report category',
    confidence: 'Confidence',
    skip: 'not a report cost',
    categories: 'Categories — ledger cost',
    categoriesHint: 'Report costs from the ledger over the last {months} months',
    accounts: 'Accounts',
    amount: 'Cost',
    search: 'Search account or name',
    empty: 'No account map — run erp:rewizor-map --propose.',
    confidenceValue: { HIGH: 'high', MEDIUM: 'medium', LOW: 'low', APPROVED: 'corrected manually' },
  },
  vehicleCard: {
    tab: 'Ledger costs',
    title: 'Ledger costs (Rewizor)',
    description: 'Accounts 505–509 matched by registration number — last 12 months.',
    empty: 'The ledger has no costs of this vehicle in the last 12 months.',
    month: 'Month',
  },
  error: 'Could not load the data.',
  retry: 'Try again',
};
